import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import blogs from "../data/blogs";

export default function BlogPage() {
  const { blogId } = useParams();
  const blog = blogs.find((b) => b.id === parseInt(blogId));
  const [imgSrc, setImgSrc] = useState(blog ? blog.image : "/images/placeholder.webp");
  const [contentHtml, setContentHtml] = useState("");

  // Always call useEffect, even if blog is undefined
  useEffect(() => {
    if (!blog) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(blog.content, "text/html");

    doc.querySelectorAll("img").forEach((img) => {
      const originalSrc = img.getAttribute("src") || "/images/placeholder.webp";
      img.setAttribute("loading", "lazy");
      img.setAttribute("src", originalSrc);
      img.setAttribute("onerror", "this.src='/images/placeholder.webp'");
      img.setAttribute("style", "width:100%;margin-top:10px;object-fit:cover;");
    });

    setContentHtml(doc.body.innerHTML);
  }, [blog]);

  if (!blog) {
    return (
      <div className="text-center mt-20">
        <p className="text-gray-700 text-lg mb-4">Blog not found</p>
        <Link to="/blog" className="text-green-600 font-semibold hover:underline">
          Back to Blogs
        </Link>
      </div>
    );
  }

  return (
    <div className="py-10 px-6 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold text-green-700 mb-4">{blog.title}</h1>
      <p className="text-gray-400 mb-6">{blog.date}</p>
      <img
        src={imgSrc}
        alt={blog.title}
        loading="lazy"
        className="w-full h-64 object-cover mb-6 rounded"
        onError={() => setImgSrc("/images/placeholder.webp")}
      />
      <p className="text-gray-700 mb-6">{blog.summary}</p>
      <div
        className="text-gray-700 leading-relaxed"
        dangerouslySetInnerHTML={{ __html: contentHtml }}
      />
      <div className="mt-6">
        <Link to="/blog" className="text-green-600 font-semibold hover:underline">
          ← Back to Blog List
        </Link>
      </div>
    </div>
  );
}
